import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { BannerInfoItem } from '@app/models/banner-info-item.model';
import { GoogleAnalyticsService } from '@app/services/_index';
import { HasAnalytics } from '@app/interfaces/_index';
import { NguCarouselConfig } from '@ngu/carousel';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss'],
  standalone: false,
})
export class BannerCarouselComponent implements OnInit, AfterViewChecked, HasAnalytics {
  carouselBanner: NguCarouselConfig;
  @Input() id: string;
  @Input() carouselDotActiveCSS = 'default-active'; // Set background color for carousel dots
  @Input() carouselSectionCSS: string; // Set section css name based on home banner Vs AP Subscription page
  @Input() carouselLeftArrowCSS: string; // Set carousel left arrows based on home banner Vs AP Subscription page
  @Input() carouselRightArrowCSS: string; // Set carousel right arrows based on home banner Vs AP Subscription page
  @Input() carouselItems: BannerInfoItem[] = []; // Pull the carousel data
  @Input() bannerPositionsCss: string; // Set various background positions

  constructor(
    private cdRef: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  /**
   * OnInit - Configure the banner carousel data and images to be loaded in carousel
   */
  ngOnInit(): void {
    this.carouselBanner = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: {
        timing: 10000, // Standard 10 sec between slides
        initialDelay: 1000,
      },
      point: {
        visible: true,
      },
      load: 2,
      custom: 'banner',
      loop: true,
      touch: true, // touch is not currently in active for vertical carousel, will enable it in future build
      vertical: {
        enabled: false,
        height: 400,
      },
    };
  }

  /**
   * After view Checks if any changes made to the carousel with the
   * angular change detection reference
   */
  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  /**
   * Add Track By Carousel item to not redraw or
   * re-render list items that have not changed. This improves performance.
   * @param index - Index of carousel array
   * @param item - Carousel list item BannerInfoItem
   * @returns carousel title
   */
  trackByCarouselItemTitle(index: number, item: BannerInfoItem): string {
    if (item && item.title) {
      return item.title;
    } else {
      // Else if item and item title is empty or undefined, default to index
      return String(index);
    }
  }

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }
}
